import { useContext } from 'react'
import { RaidContext } from './raidContextCore'

export const useRaid = () => {
  const context = useContext(RaidContext)
  if (!context) throw new Error('useRaid must be used within RaidProvider')
  return context
}
